import React from "react"
import angry from '../../img/icon/angry.png'

export default function Angry() {
   return (
      <img src={angry} alt="" />
   )
}
